"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M3.96 3.4c.28-.28.64-.4 1.05-.4.26 0 .5.06.72.18.22.12.39.3.51.52.13.24.18.5.18.79 0 .43-.11.81-.39 1.1-.27.29-.63.41-1.04.41-.25 0-.5-.06-.72-.18-.22-.12-.39-.3-.52-.53-.13-.23-.18-.5-.18-.79 0-.43.12-.81.39-1.1zM4.24 7h1.52c.45 0 .86.09 1.21.29.3049.1848.55.4293.7275.7415l2.0682 3.6355h4.4686l2.0676-3.6358c.1776-.3121.424-.5564.7381-.7412.34-.2.75-.29 1.2-.29h1.52c.45 0 .86.09 1.21.29.33.2.59.47.77.82.18.34.26.72.26 1.14V16h-2v5h-2v-5h-2v-4.7474l-.9921 1.7444H14v4.671h-1.334V21h-1.332v-3.332H10v-4.671H8.992L8 11.2526V16H6v5H4v-5H2V9.25c0-.42.08-.8.26-1.14.18-.35.44-.62.78-.82.34-.2.75-.29 1.2-.29zm13.72-3.6c.28-.28.64-.4 1.05-.4.26 0 .5.06.72.18.22.12.39.3.51.52.13.24.18.5.18.79 0 .43-.11.81-.39 1.1-.27.29-.63.41-1.04.41-.25 0-.5-.06-.72-.18-.22-.12-.39-.3-.52-.53-.13-.23-.18-.5-.18-.79 0-.43.12-.81.39-1.1z"
  }), _react.default.createElement("path", {
    d: "M11.9992 11.0003c.6619 0 1.1984-.473 1.1984-1.2658 0-.8126-.5365-1.2658-1.1984-1.2658-.6619 0-1.1984.4613-1.1984 1.2658 0 .7955.5365 1.2658 1.1984 1.2658z"
  })];
};

exports.default = _default;